export default "__VITE_ASSET__sU$DfSUZ__"